import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ButtonComponent,
  CardComponent,
  ModalComponent,
  SpinnerComponent,
  TabviewComponent,
  ToastModule,
  ToolbarComponent,
} from '@teorema/patron';
import { QuillModule } from 'ngx-quill';
import { TruncateModule } from '../../pipes/truncate.pipe';
import { FilterWidgetModule } from '../filter-widget/filter-widget.module';
import { FormModule } from '../form/form.module';
import { PaginatorModule } from '../paginator/paginator.module';
import { SearchWidgetModule } from '../search-widget/search-widget.module';
import { ResponsiveTableModule } from '../table/responsive-table.module';
import { NotificationRoutingModule } from './notification.routing';
import { NotificationConfigurationComponent } from './notifications/notification-configuration/notification-configuration.component';
import { NotificationListComponent } from './notifications/notification-list/notification-list.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { PagedListComponent } from './notifications/paged-list/paged-list.component';
import { SendingFormComponent } from './notifications/sending-form/sending-form.component';

@NgModule({
  declarations: [
    NotificationsComponent,
    NotificationListComponent,
    NotificationConfigurationComponent,
    SendingFormComponent,
    PagedListComponent,
  ],
  imports: [
    NotificationRoutingModule,
    CommonModule,
    TruncateModule,
    PaginatorModule,
    ToastModule,
    ResponsiveTableModule,
    ModalComponent,
    FilterWidgetModule,
    SearchWidgetModule,
    ToolbarComponent,
    TabviewComponent,
    FormModule,
    CardComponent,
    ButtonComponent,
    SpinnerComponent,
    QuillModule,
  ],
  exports: [NotificationListComponent],
})
export class NotificationModule {}
